module.exports = __webpack_public_path__ + "img/worldpay.79640389.png";